import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const informationPageK = {
  invoiceHistory: "information_page.invoiceHistory",
  users: "information_page.users",
  companyInformation: "information_page.companyInformation",
  information: "information_page.information",
  creditNote: "information_page.creditNote",
};

export const useInformationPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      invoiceHistory: t(informationPageK.invoiceHistory),
      users: t(informationPageK.users),
      companyInformation: t(informationPageK.companyInformation),
      information: t(informationPageK.information),
      creditNote: t(informationPageK.creditNote),
    }),
    [i18n.language]
  );
};